module.exports = __webpack_public_path__ + "media/images/nini_landing-45c395a18628c2b7fd2e87f6b0f60f4b.png";